import React, { useEffect } from 'react';
import { useNavigate, useLocation, useParams } from 'react-router';
import { useDispatch } from 'react-redux';
import { setRouteName } from '../actions/ui';

const routeNameMap = {
  ticketPicker: '/',
  'picker-with-details': '/picker-with-details',
  'tickets-reserved': '/tickets-reserved',
  upsells: '/upsells',
  checkout: '/checkout/:token',
  cart: '/cart/:token',
  pending: '/pending/:token',
  confirmation: '/confirmation/:confId',
  coupon: '/promo',
  auth: '/auth',
  authEmail: '/auth/email',
  seriesDatePicker: '/day',
  kioskTimePicker: '/day',
  memberLogin: '/member-login',
};

export const buildPathFromRouteName = (name, params) => {
  let path = routeNameMap[name];
  if (!path) return "/";
  Object.entries(params).forEach(([key, value]) => {
    path = path.replace(`:${key}`, value);
  });
  return path;
};

export function withRouterCompat(WrappedComponent) {
  return function Wrapper(props) {
    const navigate = useNavigate();
    const dispatch = useDispatch();
    const location = useLocation();
    const params = useParams();

    // helper: convert "/checkout/:token" -> /^\/checkout\/[^/]+$/
    const pathToRegex = (path) =>
      new RegExp("^" + path.replace(/:[^/]+/g, "[^/]+") + "$");

    const currentRouteName =
      Object.entries(routeNameMap).find(([name, path]) =>
        pathToRegex(path).test(location.pathname)
      )?.[0] || null;

    useEffect(() => {
      dispatch(setRouteName(currentRouteName))
    }, [currentRouteName]);

    const routerCompat = {
      locationService: {
        path: () => location.pathname
      },
      stateService: {
        transitionTo: (path) => navigate(path)
      }
    };

    return (
      <WrappedComponent
        {...props}
        router={routerCompat}
        navigate={navigate}
        currentRouteName={currentRouteName}
        params={params}
      />
    );
  };
}
